/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerFindOneStepQueryResponse, DocumentsControllerFindOneStepPathParams, DocumentsControllerFindOneStep400, DocumentsControllerFindOneStep401, DocumentsControllerFindOneStep403, DocumentsControllerFindOneStep404 } from "../../models/documentsController/DocumentsControllerFindOneStep";

function getDocumentsControllerFindOneStepUrl(id: DocumentsControllerFindOneStepPathParams["id"], processingId: DocumentsControllerFindOneStepPathParams["processingId"], stepId: DocumentsControllerFindOneStepPathParams["stepId"]) {
  const res = { method: 'GET', url: `/api/v1/documents/${id}/processing/${processingId}/steps/${stepId}` as const }  
  return res
}

/**
 * @summary Get a specific processing step
 * {@link /api/v1/documents/:id/processing/:processingId/steps/:stepId}
 */
export async function documentsControllerFindOneStep(id: DocumentsControllerFindOneStepPathParams["id"], processingId: DocumentsControllerFindOneStepPathParams["processingId"], stepId: DocumentsControllerFindOneStepPathParams["stepId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentsControllerFindOneStepQueryResponse, ResponseErrorConfig<DocumentsControllerFindOneStep400 | DocumentsControllerFindOneStep401 | DocumentsControllerFindOneStep403 | DocumentsControllerFindOneStep404>, unknown>({ method : "GET", url : getDocumentsControllerFindOneStepUrl(id, processingId, stepId).url.toString(), ... requestConfig })  
  return res.data
}